const AUTH_RETURN_TO_KEY = "lyra:wbe-auth-return-to";

export const getAuthReturnTo = () =>
  window.sessionStorage.getItem(AUTH_RETURN_TO_KEY);

export const setAuthReturnTo = (url: string) => {
  window.sessionStorage.setItem(AUTH_RETURN_TO_KEY, url);
};

export const consumeAuthReturnTo = (fallback: string) => {
  const returnTo = getAuthReturnTo() || fallback;
  window.sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
  return returnTo;
};
